module.exports = __webpack_public_path__ + "img/Jump Casting22.6206c796.jpg";